import { render, staticRenderFns } from "./DashboardRouteLink.vue?vue&type=template&id=61111986&scoped=true"
import script from "./DashboardRouteLink.vue?vue&type=script&lang=js"
export * from "./DashboardRouteLink.vue?vue&type=script&lang=js"
import style0 from "./DashboardRouteLink.vue?vue&type=style&index=0&id=61111986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61111986",
  null
  
)

export default component.exports